import styled, { css } from "styled-components";

const ContactFormStyled = styled.form.attrs({
  className: "contact-form",
})`
  ${({ theme, phoneVerifyEnabled }) => {
    const { media = {} } = theme;

    return css`
      margin: ${phoneVerifyEnabled ? "26px 0 0" : "0 0 30px"};
      .contact-form {
        &__row {
          display: flex;
          flex-wrap: wrap;

          ${media.tablet.up} {
            flex-wrap: nowrap;
          }
        }

        &__group {
          flex: 0 1 100%;
          margin-top: 20px;

          label {
            font-size: 16px;
            font-weight: 500;

            .sub-label {
              font-weight: 400;
            }
          }

          input:autofill {
            background: rgb(232, 240, 254);
          }

          &--last-name {
            ${media.tablet.up} {
              margin-left: 22px;
            }
          }

          span {
            font-size: 10px;
            font-weight: 400;
          }
        }

        &__tcpa_marketing {
          display: flex;
          font-size: 12px;
          font-weight: 300;
          line-height: 1.3;
        }
      }
      label + input {
        margin-top: 10px;
      }
    `;
  }}
`;

export default ContactFormStyled;
